import { postData } from '../../helpers/fetch';
import { globalEmitter } from '../helpers/emitter';

const getLineItem = (id: number, properties: {}, quantity: number) => {
  const data = {
    items: [
      {
        id,
        properties,
        quantity
      }
    ]
  }
  return data
}

export const addCartItem = async (id: number, properties = {}, quantity = 1) => {
  const lineItem = getLineItem(id, properties, quantity)
  const item = await postData('/cart/add.js', lineItem, 'json')
  return item
}

export const addMultipleCartItems = async (items: any) => {
  return postData('/cart/add.js', items, 'json').then((items) => {
    return items
  })
}
